import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  FetchQuickBooksPeriodReportRequest,
  PeriodReportData,
} from "@/api/fetchQuickBooksPeriodReport/types";
import { AppDispatch, AppThunk } from "@/app/store";
import { fetchQuickBooksPeriodReport } from "@/api/fetchQuickBooksPeriodReport/fetchQuickBooksPeriodReportApi";

interface PeriodReportState {
  report: PeriodReportData | null;
  loading: boolean;
  error: string | null;
}

const initialState: PeriodReportState = {
  report: null,
  loading: false,
  error: null,
};

const periodReportSlice = createSlice({
  name: "periodReport",
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    setReport(state, action: PayloadAction<PeriodReportData | null>) {
      state.report = action.payload;
    },
    clearReport(state) {
      state.report = null;
      state.error = null;
    },
  },
});

export const { setLoading, setError, setReport, clearReport } =
  periodReportSlice.actions;

export const fetchPeriodReportAction =
  (requestData: FetchQuickBooksPeriodReportRequest): AppThunk =>
  async (dispatch: AppDispatch) => {
    dispatch(setLoading(true));
    dispatch(setError(null));
    try {
      const response = await fetchQuickBooksPeriodReport(requestData);
      dispatch(setReport(response.data));
    } catch (error) {
      if (error instanceof Error) {
        dispatch(setError(error.message));
      } else {
        dispatch(setError("Failed to fetch period report"));
      }
    } finally {
      dispatch(setLoading(false));
    }
  };

export default periodReportSlice.reducer;
